import { AddScheduledReportRequest, ScheduledReport } from '@givelify/api';
import { convertToDate } from '@givelify/utils';
import { normalizeBooleanLike } from 'utils/normalizeBooleanLike';
import { SetScheduledReport, SET_SCHEDULED_REPORT } from './types';

export const setScheduledReport = (
    data: ScheduledReport,
): SetScheduledReport => {
    if (data) {
        localStorage.setItem(SET_SCHEDULED_REPORT, JSON.stringify(data));
    }
    return {
        type: SET_SCHEDULED_REPORT,
        data: {
            ...data,
            receivesNotifications: normalizeBooleanLike(
                data.receivesNotifications as unknown,
            ),
            nextRun: data.nextRun ? convertToDate(data.nextRun) : null,
            lastRun: data.lastRun ? convertToDate(data.lastRun) : null,
            createdAt: data.createdAt ? convertToDate(data.createdAt) : null,
            updatedAt: data.updatedAt ? convertToDate(data.updatedAt) : null,
        },
    };
};

export const mapScheduledReportToRequest = (
    data: ScheduledReport,
): AddScheduledReportRequest => {
    const { createdAt, lastRun, nextRun, updatedAt, updatedBy, ...payload } =
        data;
    return {
        ...payload,
        nextRunDate: nextRun ? nextRun.toISOString() : null,
    };
};
